import { render, staticRenderFns } from "./ProjectTemplates.vue?vue&type=template&id=1b0bab92"
import script from "./ProjectTemplates.vue?vue&type=script&lang=js"
export * from "./ProjectTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports